import {
  SERVICE_HOLDER_SLEEP_QUALITY_BAD,
  SERVICE_HOLDER_SLEEP_QUALITY_GOOD,
  SERVICE_HOLDER_SLEEP_QUALITY_MEDIUM,
  SERVICE_HOLDER_SLEEP_QUALITY_VERY_GOOD,
} from "./serviceHolder";

const options = [
  {
    value: SERVICE_HOLDER_SLEEP_QUALITY_VERY_GOOD,
  },
  {
    value: SERVICE_HOLDER_SLEEP_QUALITY_GOOD,
  },
  {
    value: SERVICE_HOLDER_SLEEP_QUALITY_MEDIUM,
  },
  {
    value: SERVICE_HOLDER_SLEEP_QUALITY_BAD,
  },
];

export function sleepQualityOptionList() {
  return options;
}
